import { filterEntitiesBy } from "actions/entities";
import React from 'react'
import { fetchEntities, filterEntities } from 'actions/entities'
import { connect } from 'react-redux'
import { getFilteredDossiers } from "selectors/dossiers";
import { Card, Grid, Input, Select, Form, Container } from 'semantic-ui-react'
import { getCalendars} from 'selectors/calendars'
import { getConsultationTypes } from 'selectors/consultation_types'
import NewEvent from 'components/agenda/NewEvent'
import { getFilteredCalendars} from 'selectors/calendars'
import { getFilteredConsultationTypes } from 'selectors/consultation_types'
import debounce from "../../debounce";

class NewEventsList extends React.Component {

  constructor(props) {
    super(props);
    this.state = { searchTerm: '' }
    this.debouncedSearch = debounce((searchTerm) => {
      this.props.fetchDossiers({ search: searchTerm })
    }, 350)
  }

  componentDidMount() {
    this.props.fetchEntities();
  }

  componentWillUnmount() {
    this.props.filterDossiers(null)
  }

  renderEvents() {
    const { filteredDossiers, filteredConsultationTypes, filteredCalendars } = this.props



    const events = [];

    for (const dossier of filteredDossiers) {
      for (const consultationType of filteredConsultationTypes) {
        for (const calendar of filteredCalendars) {
          if (dossier.responsibleIds?.includes(calendar.responsibleId.toString())) {
            events.push({
                          dossier,
                          consultationType,
                          calendar,
                        });
          }
        }
      }
    }

    return events.slice(0,12).map ( (eventProps) => <NewEvent {...eventProps}/>)
  }

  render () {
    const { dossiers, consultationTypes, employments, calendars, calendar} = this.props

    const selectOptionsCalendars = calendars.map((calendar) => { return { key: calendar.id, value: calendar.id, text: calendar.summary, icon: 'calendar' }})
    const selectOptionsConsultationTypes = consultationTypes.map((consultationType) => { return { key: consultationType.id, value: consultationType.id, text: consultationType.name, icon: consultationType.icon}})
    selectOptionsCalendars.unshift({key: '', value: '', text: I18n.t('components.semantic_select_field.blank_alternate')})
    selectOptionsConsultationTypes.unshift({key: '', value: '', text: I18n.t('components.semantic_select_field.blank_alternate')})

    return (
      <Grid divided padded>
        <Grid.Row centered>
          <Grid.Column width={4} textAlign={'center'}>
            <Form>
              <Form.Field>
                <Select searchable options={selectOptionsCalendars} defaultValue={selectOptionsCalendars[0] && selectOptionsCalendars[0].value} onChange={(event, data) => this.props.selectCalendar(data.value)}/>
              </Form.Field>
              <Form.Field>
                <Select searchable options={selectOptionsConsultationTypes} defaultValue={selectOptionsConsultationTypes[0] && selectOptionsConsultationTypes[0].value} onChange={(event, data) => { this.props.selectConsultationType(data.value)}}/>
              </Form.Field>
              <Form.Field>
                <Input icon='search' placeholder={I18n.t('components.entities_list.search')} transparent onChange={this.handleDossierSearchChange}/>
              </Form.Field>
            </Form>
          </Grid.Column>
          <Grid.Column width={12}>
            <Card.Group>
              { this.renderEvents() }
            </Card.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>

    )
  }

  handleDossierSearchChange = (event, props) => {
    this.debouncedSearch(props.value)
  }
}

const mapStateToProps = (state) => {
  const filters = [
    {by: 'name', getTarget: (dossier) => dossier.patient && dossier.patient.firstName + ' ' + dossier.patient.lastName },
  ]

  return {
    calendars: getCalendars(state),
    filteredCalendars: getFilteredCalendars(state),
    filteredDossiers: getFilteredDossiers('newEvent')(state, filters),
    consultationTypes: getConsultationTypes(state),
    filteredConsultationTypes: getFilteredConsultationTypes(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDossiers: (filter = {}) => {
      dispatch(fetchEntities('dossiers', { name: 'newEvent', filter: filter, page: 1 }))
    },
    fetchEntities: () =>
    {
      dispatch(fetchEntities('dossiers', { name: 'newEvent', page: 1 }))
      dispatch(fetchEntities('calendars'))
      dispatch(fetchEntities('consultationTypes'))
    },
    filterDossiers: (value) => {
      dispatch(filterEntitiesBy('dossiers', 'name', value))
    },
    selectCalendar: (id) => {
      dispatch(filterEntities('calendars', { id: id}))
    },
    selectConsultationType: (id) => {
      dispatch(filterEntities('consultationTypes', { id: id}))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewEventsList)
